// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper---x5UYp","content":"content---ZnhiH"};